import { render, staticRenderFns } from "./FlipCountdown.vue?vue&type=template&id=428e6e4b&scoped=true&"
import script from "./FlipCountdown.vue?vue&type=script&lang=js&"
export * from "./FlipCountdown.vue?vue&type=script&lang=js&"
import style0 from "./FlipCountdown.vue?vue&type=style&index=0&id=428e6e4b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428e6e4b",
  null
  
)

export default component.exports